import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

let SortDescending = (props) => {
    const baseProps = {
        viewBox: '0 0 24 24',
    };

    const combineProps = Object.assign({}, baseProps, props);

    return (
        <SvgIcon {...combineProps}>
            <path d="M10,13V11H18V13H10M10,19V17H14V19H10M10,7V5H22V7H10M6,17H8.5L5,20.5L1.5,17H4V4H6V17Z" />
        </SvgIcon>
    );
}

export default SortDescending;
